var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 243,
    viewBox: "0 0 320 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 0H-1V236.25C16.5822 239.625 74.7359 243 156.491 243C233.731 243 301.581 239.625 320 236.25V0Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(295.925 287.131) rotate(-135.961) scale(413.048 450.635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D2B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476744,
    stopColor: "#0CA7B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016E97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/header-background.24c2f5f79d8aa93b3ddb20649fa70ff2.svg";
export { ForwardRef as ReactComponent };